export default {
    sync_ctc_info_title: "Sincronizar información del CTC",
    sync_ctc_info_description: "¿Estás seguro de que quieres sincronizar la información de CTC?",
    sync_ctc_info_label: "Sincronizar",
    sync_ctc_info_success_message: "La información de CTC se ha sincronizado",
    sync_ctc_info_error_message: "La información de CTC no se ha sincronizado",
}